// vendors
import React from 'react';

const IconCalendar = (props) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 37.37 34.77' {...props}>
    <g
      strokeWidth='2px'
      strokeLinejoin='round'
      style={{ stroke: 'currentColor' }}
    >
      <rect
        fill='none'
        className='cls-1'
        x='1'
        y='5.95'
        width='35.37'
        height='27.82'
      />
      <line className='cls-1' x1='1' y1='16.31' x2='36.37' y2='16.31' />
      <line className='cls-1' x1='8.01' x2='8.01' y2='9.5' />
      <line className='cls-1' x1='18.69' x2='18.69' y2='9.5' />
      <line className='cls-1' x1='29.36' x2='29.36' y2='9.5' />
    </g>
  </svg>
);

export default IconCalendar;
